import { useContext } from 'react';
import { SignupContext } from '@context/signup_context';

const useSignupContext = () => {
    return useContext(SignupContext);
};

export default useSignupContext;
